module.exports = __webpack_public_path__ + "assets/images/probe_3_wire_config.png";